export interface Category {
  name: string;
  slug: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  { name: 'Shoes', slug: 'shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies/Sweaters', slug: 'hoodies-sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', slug: 't-shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', slug: 'jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-honour-line' },
  { name: 'Pants/Shorts', slug: 'pants-shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', slug: 'headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-smile-line' },
  { name: 'Sets', slug: 'sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear/Underpants', slug: 'underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jersey', slug: 'jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line' },
  { name: 'Accessories', slug: 'accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', slug: 'bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
  { name: 'Belts', slug: 'belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link-m' },
  { name: 'Perfumes', slug: 'perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-contrast-drop-line' },
  { name: 'Other Stuff', slug: 'other-stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';